import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["list"]

  publish(event) {
    let [data] = event.detail
    this.listTarget.innerHTML = data.content
  }
}